module.exports = __webpack_public_path__ + "static/media/How does Print Case work.cb4d7dd0.png";